import React from "react";
import "../assets/css/Main.css";
import { Link } from "react-router-dom";
import dashboard from "../assets/images/dashboard.png";
import event from "../assets/images/event.svg";
import bell from "../assets/images/notification.png";
import account from "../assets/images/account.svg";
import MW from "../assets/images/MW.png"
function Aside() {
  return (
    <aside id="sidebar">
      <ul className="menu-btn">
        <li id="logo">
          <img src={MW}></img>
        </li>
        {/* Tooltip library added for showing tips on hover  */}
        {/*Dashboard button  */}

        <li data-toggle="tooltip" data-placement="right" title="Dashboard">
          <Link to="/">
            <img className="menu-img" src={dashboard} />
          </Link>
        </li>
        {/* Week View Button  */}
        <li data-toggle="tooltip" data-placement="right" title="Week View">
          <Link to="week-view">
            <img className="menu-img" src={event} />
          </Link>
        </li>
        {/* Notifications button  */}
        <li data-toggle="tooltip" data-placement="right" title="Notifications">
          <Link to="/notifications">
            <img className="menu-img" src={bell} />
          </Link>
        </li>
        {/* My account button  */}
        <li data-toggle="tooltip" data-placement="right" title="My Account">
          <Link to="/profile">
            <img className="menu-img" src={account} />
          </Link>
        </li>
      </ul>
    </aside>
  );
}

export default Aside;
